<template lang="pug">
div.play-area.overflow-hidden(:style='playAreaStyle')
  //slot(v-if='appTicker',name='default',
    v-bind:ticker='appTicker',
    v-bind:tickFunction='tickFunction',
    v-bind:app='app'
    )
  resize-observer(v-if='!disableResize', @notify='resizeListener')
  pbc-message(ref='message')
  #fpsmeter
  //button.button.is-warning(@click='printEntities()') Print
  // <div class="button" @click='tickFunction(30)'>AAAAAAAAAAAA</div>

  .hero.is-warning(v-if='showErrors && gameState === "error"', style='padding-top:40px')
    .hero-head
      div
        h1.title
          | Whoops! An error occurred during loading. Please check your internet connection and try again.
    .hero-body
      div
        button.button.is-primary(@click='onReload()') Reload

  .flex.flex-row.h-full(v-if='isBusyResizing')
    div.mx-4.w-full.self-center
      .spinner
      .text-gray-600.text-xs.tracking-tight.text-center Resizing...

  div.flex.flex-row.h-full(v-if='gameState === "loading"')
    div.mx-4.w-full.self-center
      .text-gray-600.text-xs.tracking-tight.text-center Loading...
      .shadow.bg-gray-700.self-center.mx-4
        .bg-orange-500.text-xs.leading-none.py-1.text-center.text-white(
          :style='{"width": assetsLoadedPerc}'
        ) {{assetsLoadedPerc}}

  //p.text-white.ml-48 {{debug}}
  .gamecanvas
  //.testcanvas

</template>

<script>
require('@/play/game/safari.js');
import Assets from '@/play/game/assets.js';
import PixiAppPool from './pixiAppPool.js';
const pixiAppPool = new PixiAppPool();
import PbcMessage from '@ui/molecules/PbcMessage.vue';
import * as PIXI from 'pixi.js-legacy';
window.PIXI = PIXI;
global.PIXI = PIXI;
require('pixi-layers');

import { debounce, extend, keys, cloneDeep, clone, isString, values, toPairs, uniq, isObject } from 'lodash';
//const $script = require('scriptjs');
require('./rafshim.js');
//this.$options.components.BoardView = require('./BoardView.vue')
//const async = require('async');
import forEach from 'async/forEach.js';
let PulseLoader = require('vue-spinner/src/PulseLoader.vue');
// import * as PIXI from 'pixi.js';
// window.PIXI = PIXI;

// TODO: this breaks canvas render on destroy:
// this.plugins[o].destroy is not a function
//require('pixi-tilemap');

const Crash = require("crash-colliders");
const EntityManager = require('pbc-ecs').EntityManager;

import CreateSystems from '../game/systems.js';
const Components = require('../game/components.js');
// require('pixi-layers');
//require('../../pixi-picture.min.js');
const pixiPackerParser = require("./pixiPackerLoader.js")
//const CreateSystems = require('../game/systems.js');
const Util = require('../game/util.js');
import PixiHammer from '@edit/render/pixihammer.js';

function GameObjects() {
}

export default{
  inject:['api'],
  props: {
    gamedata:{
      type:Object,
      required:true
    },
    startPixi:{
      type:Boolean,
      default:true
    },
    isFullscreen:{
      type:Boolean,
      default:false
    },
    enableDebug:{
      type:Boolean,
      default:false
    },
    enableErrorHandler:{
      type:Boolean,
      default:false
    },
    data:{
      type:Object,
      default() {
        return {}
      }
    },
    gameEndControls:{
      type:Boolean,
      default:true
    },
    gameName:{
      type:String,
      default:'unknown'
    },
    gameId:{
      type:String,
      default:'editor'
    },
    showErrors:{
      type:Boolean,
      default:true
    },
    incomingVariables:{
      type:Object,
      default() {
        return {};
      }
    },
    incomingEvents:{
      type:Array,
      default() {
        return [];
      }
    },
    user: {
      type:Object,
      default() {
        if (this.$store) {
          return this.$store.state.user;
        } else {
          return {
            identityId:'pass_a_user',
            id:'pass_a_user',
            _id:'pass_a_user',
            isAnonymous:true
          }
        }
      }
    },
    hasCustomLoader:{
      type:Boolean,
      default:false
    },
    enableLetterbox:{
      type:Boolean,
      default:false
    },
    frameTimeMultiplier:{
      type:Number,
      default:1
    },
    initialSceneNum:{
      type:Number,
      default:-1
    },
    initialTransforms:{
      type:Array,
      default:undefined
    },
    enableBlackListMessage:{
      type:Boolean,
      default:false
    },
    options:{
      type:Object,
      default:() => {
        return {
          forceCanvas:false,
          legacy:false,
          antialias:true,
          forceFXAA:true,
          transparent:false,
          preserveDrawingBuffer:false,
          cacheAsBitmap:true
        }
      }
    },
    useWindowDims:{
      type:Boolean,
      default:false
    },
    overrideCamera:{
      type:Object,
      default:null
    },
    callbacks:{
      type:Object,
      default() {
        return {
          setDebug(debug) {
          }
        }
      }
    },
    enablePacker:{
      type:Boolean,
      default:false
    },
    paused:{
      type:Boolean,
      default:false
    },
    disableResize: {
      type:Boolean,
      default:false
    },
    enableWatermark: {
      type: Boolean,
      default: false
    },
    layers:{
      type:Object,
      default() {
        return {};
      }
    },
    overrideAspect: {
      type: String,
      required: false
    },
    tickResolution: {
      type: Number,
      default: -1
    }
  },
  data() {
    let activeSceneNum = this.initialSceneNum;
    if (typeof(this.initialTransforms) === 'undefined' && activeSceneNum === -1) {
      activeSceneNum = 0;
      this.gamedata.scenes.forEach( (s,i) => {
        if (s.default) {
          activeSceneNum = i;
        }
      });
    }
    const debouncedResize = debounce(this.onResize.bind(this), 200);
    const defaultOptions = {
      forceCanvas:false,
      legacy:false,
      antialias:true,
      forceFXAA:true,
      transparent:false,
      preserveDrawingBuffer:false,
      cacheAsBitmap:true,
    }
    const pixiAppKey = new Date().getTime();

    return {
      pixiAppKey,
      usingOptions:{...defaultOptions, ...this.options},
      debouncedResize,
      showBlacklistMessage:false,
      spritesLoaded:0,
      killRender:false,
      bla:0,
      counter:0,
      activeSceneNum,
      incomingVariablesProcessed:{},
      isFirstFrame:true,
      rendererType:'unknown',
      playing:true,
      variablesToStore:{},
      pauseRender:true,
      soundsLoaded:0,
      messages:[],
      soundsTotal:0,
      spritesTotal:0,
      mipmappedTotal:0,
      pressingKeys:{},
      idealFps:1000.0 / 60,
      maxFrameTime:1000.00 / 20,
      accumulator:0,
      gameState:'loading',
      showInput:false,
      inputData:{},
      inputFormOptions:{
        validateAfterLoad:false,
        validateAfterChanged:true
      },
      inputIsValid:false,
      inputSchema:{
        fields:[
          {
            type: "input",
            label: "Change in X",
            model: "dx",
            required:true
          },
          {
            type: "input",
            label: "Change in Y",
            model: "dy",
            required:true
          },
          {
            type: "input",
            label: "Duration",
            model: "t",
          },
          {
            type: "tween-select",
            label: "Tween",
            model: "tween",
          },

        ]
      },
      timeSinceStart: 0,
      isBusyResizing: false,
      loaded: false,
      hasVideComponents: false,
      debug: 'lol'
    }
  },
  components: {
    PulseLoader,
    PbcMessage
  },
  beforeCreate() {
  },
  beforeDestroy() {
    this.assets.cleanup();
    this.assets = null
    this.loader.reset();
    this.loader.destroy(true);
    this.loader = null;
    this.resources = null;
    this.mipmappedTextures = null;
    this.doCleanup();
  },
  methods:{
    checkForVideos() {
      const videoComponents = this.allComponents.filter( ({type}) => {
        return type === 'video';
      });
      if (videoComponents.length) {
        this.hasVideComponents = true;
      } else {
        this.hasVideComponents = false;
      }
    },
    emitVideoPlayingPrompt(data) {
      this.$emit('prompt-video', data);
    },
    addWatermark(container) {
      const renderer = this.app.renderer;
      let {width,height} = renderer.view;
      width /= renderer.resolution;
      height /= renderer.resolution;

      const text = new PIXI.Text('playboxcade.com',{fontFamily : 'Arial', fontSize: 14, fill : 0xffffff, align : 'center'});

      const background = new PIXI.Graphics();
      background.beginFill(0x7F3C3B);
      background.drawRect(-text.width - 8, -text.height - 8, text.width+ 16, text.height+ 16);
      background.endFill();
      background.position.x = width/2;
      background.position.y = height/2;
      container.addChild(background);

      text.position.x = width/2 -4;
      text.position.y = height/2 -4;
      text.anchor.x = 1;
      text.anchor.y = 1;
      container.addChild(text);
      const layerGroup = new PIXI.display.Group(99999);
      const layer = new PIXI.display.Layer(layerGroup);
      text.parentLayer = layer;

      const layerGroup2 = new PIXI.display.Group(99998);
      const layer2 = new PIXI.display.Layer(layerGroup);
      container.parentLayer = layer;

      this.app.stage.addChild(layer);
      this.app.stage.addChild(layer2);

    },
    resizeListener() {
      if (this.disableResize) {
        return;
      }
      const el = this.$el.querySelectorAll('.gamecanvas')[0];
      if (el && this.app) {
        this.app.stop();
        this.pauseRender = true;
        this.debouncedResize();
      }
    },
    gotoGame(gameId) {
      this.$emit('goto-game', {gameId});
    },
    logStat(logEvent) {
      this.$emit('log-stat', logEvent);
    },
    runStoreSweep() {
      for (let key in this.variablesToStore) {
        const val = this.variablesToStore[key];
        if (!isNaN(val)) {
          window.localStorage.setItem(key, ''+val);
        } else {
          window.localStorage.setItem(key, val);
        }
      }
      this.variablesToStore = {};
    },
    storeVariable(key, val) {
      this.variablesToStore[key] = val;
    },
    doToast(line, type) {
      this.$toasted.show(line, {
        duration:3000,
        type
      });
    },
    printEntities() {
      console.log(this.gameobjects.entities._entities.map( (ent) => {
        let myUuid = '<none>';
        let parentUuid = '<none>';
        if (ent.uuid) {
          myUuid = ent.uuid.uuid;
        }
        if (ent && ent.uuid && ent.uuid.parentTransform && ent.uuid.parentTransform.uuid) {
          parentUuid = ent.uuid.parentTransform.uuid.uuid
        }
      }).join("\n"))
    },
    handleFrameError(e) {
      this.$emit('frame-error', {
        e
      })
      throw e;
    },
    addDebug(line, options = {}) {
      return;
      const defaults = {
        duration:1400
      }
      options = extend({}, defaults, options);
      this.prevToast = this.$toasted.show(line, options);
    },
    inputClose(e) {
      if (e && e.preventDefault) {
        e.preventDefault();
      }
      const bodyEl = document.querySelector('body')
      bodyEl.style.position = '';
      this.showInput = false;
      if (this.inputIsValid) {
        keys(this.inputData).forEach( (k) => {
          if (this.formatters[k]) {
            this.inputData[k] = this.formatters[k](this.inputData[k])
          }
        });
      }
      this.inputCallbacks && this.inputCallbacks.close();
      this.inputCallbacks && this.inputCallbacks.onValidated(this.inputIsValid, this.inputData);
      this.pauseRender = false;
    },
    onValidated(o) {
      const {isValid, errors} = o;
      this.inputIsValid = isValid;
      this.gameobjects.inputIsValid = isValid;
    },
    askUserInput(schema, store, callbacks, formatters) {
      // stupid iOS
      const bodyEl = document.querySelector('body')
      bodyEl.style.position = 'fixed';
      this.showInput = true;
      this.pauseRender = true;
      this.inputSchema = schema;
      this.formatters = formatters;
      this.inputSchema.fields.push({
        type:'submit',
        buttonText:'Continue',
        onSubmit:this.inputClose.bind(this),
        validateBeforeSubmit:true
      })
      this.inputData = store;
      this.inputCallbacks = callbacks;
    },
    getTransforms(scene) {
      return ((this.activeScene||{}).transforms||[]);
    },
    runInteractionSystems(dt) {
      return;
      dt = dt || 0;
      this.Systems.runKeyController(dt);
      this.Systems.runSwipeController(dt);
      this.Systems.runTapController(dt);
      this.Systems.runPressController(dt);
      this.Systems.runPanController(dt);

      const oldPress = cloneDeep(this.gameobjects.interaction.press);
      const oldKeys = cloneDeep(this.gameobjects.interaction.keysPressed);
      const oldPan = cloneDeep(this.gameobjects.interaction.pan)

      this.gameobjects.interaction = {}
      if (oldPress) {
        this.gameobjects.interaction.press = oldPress;
      }
      if (oldKeys) {
        this.gameobjects.interaction.keysPressed = oldKeys;
      }
      if (oldPan) {
        this.gameobjects.interaction.pan = oldPan;
      }
    },
    base64(str) {
      return 'data:application/json;base64,' + btoa(str);
    },
    async start() {
      
      this.allComponents = [];
      this.allLinks = [];
      for (let i = 0; i < (this.gamedata.scenes||[]).length; i++) {
        const scene = this.gamedata.scenes[i];
        this.allComponents.push(... scene.components);
        this.allLinks.push(... scene.links);
      }
      for (let i = 0; i < (this.gamedata.toybox||[]).length; i++) {
        const toy = this.gamedata.toybox[i];
        this.allComponents.push(... toy.components);
        this.allLinks.push(... toy.links);
      }

      this.allComponents.push(...(this.gamedata.components||[]));
      this.allLinks.push(...(this.gamedata.links||[]));

      this.checkForVideos();


      // check for remixes
      this.i = Math.random();
      const dim = this.getDimensions();

      this.loader = new PIXI.Loader();
      this.assets = new Assets(this.api, this.loader, this, this.enablePacker ? this.gamedata.build : undefined, this.gamedata.id);
      const {mipmappedTextures, resources, assets} = await this.assets.load(this.allComponents, this.allLinks);
      this.prevAssets = assets;
      this.resources = resources;
      this.mipmappedTextures = mipmappedTextures;

      this.loaded = true;

      if (this.startPixi) {
        this.gameState = 'playing';
        this.$emit('loaded');
      } else {
        this.gameState = 'loaded';
      }

    },
    onReload() {
      this.gameState = 'loading';
      this.start();
    },
    onLoadSound(name, howlerSound, callback) {
      this.sounds[name] = howlerSound;
      this.soundsLoaded++;
      callback(null, howlerSound);
    },
    onLoadSoundError(name, callback, id, err) {
      this.soundsLoaded++;
      callback(err);
    },
    cleanup() {
      //console.log('[destroying]');
      this.killRender = true;
      window.cancelFrame(this.raf);

      this.Systems.removeAllEntities();

      const cleanupFrames = 6;
      for (let i = 0; i < cleanupFrames; i++) {
        try {
          this.Systems.runSystems(16);
        } catch (e) {
          console.warn('error during cleanup', e);
        }
      }

      this.Systems.destroy();

      this.entityManager.removeAllEntities();


      if (this.app) {
        //this.app.stage.
        const el = this.$el.querySelectorAll('.gamecanvas')[0];
        if (!this.hasVideComponents) {
          this.debug = 'gl';
          pixiAppPool.release(this.pixiAppKey, el, this.app);
        } else {
          this.debug = 'canvas';
          pixiAppPool.releaseCanvas(this.pixiAppKey, el, this.app);
        }
        this.app = null;
      }
      if (this.sounds) {
        keys(this.sounds).forEach( (k) => {
          const sound = this.sounds[k];
          sound.unload();
          delete this.sounds[k];
        } );
      }


      delete this.entityManager;
      delete this.gameobjects;
      this.Systems = null;
      //console.log('[destroyed]');
    },
    doCleanup() {
      if (this.createGameTimer) {
        clearTimeout(this.createGameTimer);
      }
      this.destroyed = true;
      if (this.$vhcheck) {
        this.$vhcheck.removeListener('update', this.resized);
      }
      clearInterval(this.storeSweeper);
      if (this.app) {
        this.app.stage.off('touchstart', this.onTap);
        this.app.stage.off('pointerdown', this.onPointerDown);
        this.app.stage.off('pointerup', this.onPointerUp);
        window.removeEventListener('pointerup', this.onPointerUpOutside);
        //this.app.stage.off('pointerdown', this.onTap);

        window.removeEventListener('keydown', this.onKeyDown);
        window.removeEventListener('keyup', this.onKeyUp);

        this.cleanup();

      }

      if (this.meter) {
        this.meter.destroy();
      }

    },
    onPause() {
      this.playing = false;
    },
    onPlay() {
      this.playing = true;
    },
    onStep() {
      if (!this.enableErrorHandler) {
        this.tickFunction(1000/20);
      } else {
        try {
          this.tickFunction(1000/20);
        } catch (e) {
          console.error(e);
          this.handleFrameError(e);
        }
      }
      this.app.renderer.render(this.app.stage);

    },
    onRestart() {
      this.gameState = 'win';
      setTimeout( () => {
        this.gameState = 'playing';
      }, 100);
    },
    createGame() {
      if (this.destroyed) {
        return;
      }
      this.accumulator = 0;
      if (this.app) {
        this.cleanup();
      }
      const el = this.$el.querySelectorAll('.gamecanvas')[0];
      const dim = this.getDimensions();
      this.prevWidth = dim.width /= 1;
      this.prevHeight = dim.height /= 1;
      let forceCanvas = this.usingOptions.forceCanvas;
      if (this.$route && this.$route.query.webgl) {
        forceCanvas = false
      }
      if (this.$route && this.$route.query.canvas) {
        forceCanvas = true
      }

      let legacy = this.usingOptions.legacy;
      if (this.$route && this.$route.query.legacy) {
        legacy = true
      }

      let resolution = window.devicePixelRatio || ratio;
      if (typeof(this.usingOptions.resolution) !== 'undefined') {
        if (this.usingOptions.resolution !== -1) {
          resolution = this.usingOptions.resolution;
        }
      }


      // hardcore to resolution to 1 to test text rendering
      //resolution = 1;

      let antialias = this.usingOptions.antialias;
      let forceFXAA = this.usingOptions.forceFXAA;
      let preserveDrawingBuffer = this.usingOptions.preserveDrawingBuffer;
      let transparent = this.usingOptions.transparent;

      dim.width /= 1;
      dim.height /= 1;

      console.log('SET WIDTH/HEIGHT', dim.width, dim.height);

      //const pixiWidth = dim.width / resolution;
      //const pixiHeight = dim.height / resolution;
      const pixiWidth = dim.width;
      const pixiHeight = dim.height;
      if (!this.hasVideComponents) {
        this.debug = 'gl';
        this.app = pixiAppPool.take(this.pixiAppKey, el, {
          width:pixiWidth,
          height:pixiHeight,
          forceCanvas,
          preserveDrawingBuffer,
          transparent:false,
          legacy,
          antialias:true,
          resolution,
          //resolution:1,
          autoResize:true,
          roundPixels: true,
          //roundPixels:true,
          forceFXAA,
          //roundPixels:true,
        }, this.ticker.bind(this));
      } else {
        this.debug = 'canvas';
        this.app = pixiAppPool.takeCanvas(this.pixiAppKey, el, {
          width:pixiWidth,
          height:pixiHeight,
          forceCanvas:true,
          preserveDrawingBuffer,
          transparent:false,
          legacy,
          antialias,
          resolution,
          //resolution:1,
          autoResize:true,
          //roundPixels:true,
          forceFXAA,
          //roundPixels:true,
        }, this.ticker.bind(this));
      }
    //this.app.ticker.add( this.ticker.bind(this) );
      //this.app.view.addEventListener("webglcontextlost", () => {
        //this.$toasted.show('webgl error');
      //})
      //this.app.view.addEventListener("webglcontextcreationerror", () => {
        //this.$toasted.show('b rats 2');
      //})


      this.screenWidth = dim.width;
      this.screenHeight = dim.height;
      if (this.gamedata.game && this.gamedata.game.bgcolor) {
        this.app.renderer.backgroundColor = parseInt(this.gamedata.game.bgcolor.replace('#','0x'));
      }

      if (this.app.renderer.type === PIXI.RENDERER_TYPE.WEBGL) {
        this.rendererType = 'webgl';
      } else {
        this.rendererType = 'canvas';
      }

      // HEH?
      this.app.stage = new PIXI.display.Stage();
      this.app.stage.group.enableSort = true;
      this.app.stage.sortableChildren = true;

      this.app.stage.hitArea = new PIXI.Rectangle(-10000,-10000,20000,20000);

      const transformContainer = this.app.stage;
      const screenContainer = new PIXI.Container();
      if (this.enableWatermark) {
        this.addWatermark(screenContainer);
      }
      this.app.stage.addChild(screenContainer);
      //const screenContainer = this.app.stage;
      const hasAdvancedTouch = this.allComponents.filter( (c) => {
        return c.type === 'pan' || c.type === 'swipecontroller' || c.type === 'feature';
      }).length > 0;
      const hammerOptions = {
        enablePan:true
      }
      if (hasAdvancedTouch) {
        // NOTE: block vertical pans for PBC because users need to scroll
        // vertically
        this.hammer = new Hammer.Manager(el, {
          touchAction:'pan-y'
          //touchAction:'pan-y'
        })
        const pan = new Hammer.Pan({
          direction: Hammer.DIRECTION_HORIZONTAL,
          threshold:15,
          pointers:1
        })
        const swipe =  new Hammer.Swipe({
          direction: Hammer.DIRECTION_HORIZONTAL,
          threshold:5,
          velocity:0.15
        })
        this.hammer.add(pan);
        this.hammer.add(swipe)

        pan.recognizeWith(swipe);

        this.hammer.on('panstart', this.onPanStart);
        this.hammer.on('panmove', this.onPan);
        this.hammer.on('panend', this.onPanEnd);

        //this.hammer.on('swipe', this.onSwipe);
        this.hammer.on('swipeleft', this.onSwipeDir.bind(this, 'left'));
        this.hammer.on('swiperight', this.onSwipeDir.bind(this, 'right'));
        this.hammer.on('swipeup', this.onSwipeDir.bind(this, 'up'));
        this.hammer.on('swipedown', this.onSwipeDir.bind(this, 'down'));

        // NOTE: block vertical pans for PBC because users need to scroll
        // vertically
        this.app.view.style['touch-action'] = 'pan-y'
        hammerOptions.enablePan = false;
      } else {
        this.hammer = new Hammer.Manager(el, {
          touchAction:'auto'
        })
        // TODO: for PBC main page - only allow pan-x
        this.app.view.style['touch-action'] = 'auto'
        hammerOptions.enablePan = false;
      }

      if (!hammerOptions.enablePan) {
        this.app.renderer.plugins.interaction.autoPreventDefault = false;
      }
      this.app.stage.interactive = true;
      //this.app.renderer.plugins.interaction.destroy();

      //this.app.stage.on('touchstart', this.onTap);
      this.app.stage.on('pointerdown', this.onPointerDown);
      this.app.stage.on('pointerup', this.onPointerUp);
      window.addEventListener('pointerup', this.onPointerUpOutside);
      //this.app.stage.on('pointerdown', this.onTap);

      //transformContainer.on('hammertap', this.onTap);
      //transformContainer.on('hammerpress', this.onPointerDown);
      //transformContainer.on('hammerpressup', this.onPointerUp.bind(this));

      

      this.entityManager = new EntityManager();

      // The application will create a canvas element for you that you 
      // can then insert into the DOM.

      //el.appendChild(this.app.view);

          //this.$toasted.show('create',{duration:2000});
      this.initGame(this.loader, this.resources, this.sounds, this.mipmappedTextures);


    },
    getDimensions() {
      if (!this.$el) {
        return {
          width:10,
          height:10
        }
      }
      const el = this.$el
      let bb = el.getBoundingClientRect();
      const boundingBox = {
        width:bb.width,
        top:bb.top,
        left:bb.left,
        right:bb.right,
        bottom:bb.bottom,
        height:bb.height,
      }

      let windowWidth = window.innerWidth;
      let windowHeight = window.innerHeight;
      if (window.visualViewport) {
        windowWidth = window.visualViewport.width;
        windowHeight = window.visualViewport.height;
      }
      return {
        // Math.min important for triviaforge-shell?
        height:Math.min(bb.height, windowHeight),
        width:Math.min(bb.width, windowWidth)
      }

    },
    forceResize() {
      this.onResize();
    },
    forceRestart() {
      this.onRestart();
    },
    onResize() {
      if (this.disableResize) {
        return;
      }
      if (!this.app || !this.app.renderer) {
        return;
      }
      //var w = window.innerWidth;
      //var h = w * 9/16;
      //var h = window.innerHeight;

      //this part resizes the canvas but keeps ratio the same    
      //this.app.renderer.view.style.width = w + "px";    
      //this.app.renderer.view.style.height = h + "px";    

      //this.paused = true;
      const el = this.$el.querySelectorAll('.gamecanvas')[0];



      this.app.stop();
      this.pauseRender = true;
      window.requestAnimationFrame( () => {
      //setTimeout( () => {
        const dim = this.getDimensions();
        var w = dim.width;
        var h = dim.height;
        //console.log('resize', w, h, 'prev', this.prevWidth, this.prevHeight);
        if (Math.abs(this.prevWidth - w) < 10 && Math.abs(this.prevHeight - h) < 10) {
        //if (false) {
          this.app.start();
          el.style.display = 'block'
          this.paused = false;
          this.prevWidth = w;
          this.prevHeight = h;
          return;
        }

        this.isBusyResizing = true;
        el.style.display = 'none'

        this.prevWidth = w;
        this.prevHeight = h;

        this.app.renderer.resize(w,h);
        this.Systems.resize(w,h);
        /*
        this.$refs.message.show({
          title: `size: ${w}x${h} / prev ${this.prevWidth}/${this.prevHeight}`
        });
        */
        this.$emit('resized', {
          width:w,
          height:h
        })
        this.app.start();
        this.pauseRender = false;
        //this.paused = false;
        this.isBusyResizing = false;

        el.style.display = 'block';
      //})

      });
      //}, 800);
    },
    next() {
      if (this.$ma) {
        this.$ma.trackEvent({
          category:'gameNext',
          action:this.gameName,
          label:this.gameName
        });
      }
    },
    onPointerDown(o) {
      if (this.gameobjects.interaction.press) {
        return;
      }
      const pos = o.data.global;

      this.Systems.pointerDown();
      this.gameobjects.interaction.press = {
        type:'press',
        pos:cloneDeep(pos)
      }
      this.addDebug(`press ${pos.x} / ${pos.y}`);

      this.runInteractionSystems();
      //this.oneTick(new Date().getTime());

    },
    onPointerUpOutside() {
      this.Systems.pointerUpOutside();
    },
    onPointerUp(o) {
      this.addDebug('pressup');
      if (this.gameobjects && this.gameobjects.interaction) {
        if (this.gameobjects.interaction.press) {
          const {x,y} = o.data.global;
          const x2 = this.gameobjects.interaction.press.pos.x;
          const y2 = this.gameobjects.interaction.press.pos.y;

          const xpart = (x2 - x);
          const ypart = (y2 - y);

          const dist = Math.sqrt(xpart * xpart + ypart * ypart);
          if (dist < 12) {
            //this.addDebug('tapped!');
            this.gameobjects.interaction.tap = cloneDeep(this.gameobjects.interaction.press);
          }
        }
        delete this.gameobjects.interaction.press;
      }
      this.Systems.pointerUp();
      //this.runInteractionSystems();
    },
    onTap(o) {
      this.addDebug('tap');
      o.stopPropagation();

      delete this.gameobjects.interaction.press;
      this.gameobjects.interaction.tap = {
        type:'tap',
        pos: clone(o.data.point)
      }

      this.runInteractionSystems();

      this.$emit('tap');
      //this.oneTick(new Date().getTime());

    },
    onPanStart(o) {
      this.gameobjects.interaction.panStart = {
        startX:o.srcEvent.offsetX,
        startY:o.srcEvent.offsetY
      }
      this.panPrev = {
        x:o.srcEvent.offsetX,
        y:o.srcEvent.offsetY,
      }
      this.panCenter = clone(o.center);
      this.addDebug(`panStart`)
    },
    onPan(o) {
      const panDiff = {
        x:o.center.x - this.panCenter.x,
        y:o.center.y - this.panCenter.y,
      }
      const panAngle = Math.atan2(panDiff.y, panDiff.x);
      const {center,deltaX,deltaY,velocity,velocityX,velocityY} = o;
      if (this.prevToast) {
        this.prevToast.goAway(0);
      }
      const prevDiff = {
        x:o.center.x - this.panPrev.x,
        y:o.center.y - this.panPrev.y
      }
      const prevRotation = Math.atan2(prevDiff.y, prevDiff.x)
      //this.addDebug(`pan: ${deltaX}/${deltaY} : ${velocityX}/${velocityY}`)
      //this.addDebug(`pan: ${center.x}/${center.y}`);
      this.gameobjects.interaction.pan = {
        type:'pan',
        direction:o.additionalEvent,
        length:o.distance,
        x:o.srcEvent.offsetX,
        y:o.srcEvent.offsetY,
        rotation:panAngle,
        prevRotation,
        velocityX,
        velocityY,
        velocity
      }
    },
    onPanEnd(o) {
      this.addDebug('panEnd');
      this.gameobjects.interaction.panEnd = {
        endX:o.srcEvent.offsetX,
        endY:o.srcEvent.offsetY
      }
    },
    onSwipeDir(direction, o) {
      this.gameobjects.interaction.swipe = {
        type:'swipe',
        data:o,
        direction
      }
    },
    normalizeKeyname(o) {
      return o.key;
    },
    onKeyDown(o, event) {
      if (!this.gameobjects|| !this.gameobjects.interaction) {
        return;
      }
      if (!this.gameobjects.interaction.keysPressed) {
        this.gameobjects.interaction.keysPressed = {}
      }
      if (!this.gameobjects.interaction.keysDown) {
        this.gameobjects.interaction.keysDown = {}
      }

      this.gameobjects.interaction.keysPressed[this.normalizeKeyname(o)] = {
        data:o,
        key:o.key
      }
      if (!this.pressingKeys[this.normalizeKeyname(o)]) {
        this.gameobjects.interaction.keysDown[this.normalizeKeyname(o)] = {
          data:o,
          key:o.key
        }
        this.pressingKeys[this.normalizeKeyname(o)] = true;
      }

      //o.preventDefault();
      this.runInteractionSystems();
      //this.oneTick(new Date().getTime());
      return false;

    },
    onKeyUp(o) {
      if (!this.gameobjects) {
        return;
      }
      if (!this.gameobjects.interaction.keysPressed) {
        this.gameobjects.interaction.keysPressed = {}
      }
      delete this.gameobjects.interaction.keysPressed[this.normalizeKeyname(o)];
      if (!this.gameobjects.interaction.keysUp) {
        this.gameobjects.interaction.keysUp = {}
      }
      this.gameobjects.interaction.keysUp[this.normalizeKeyname(o)] = {
        data:o,
        key:o.key
      }
      delete this.pressingKeys[this.normalizeKeyname(o)];
      this.runInteractionSystems();
      //this.oneTick(new Date().getTime());
    },
    async restartGame(reload=false) {
      if (!this.app) {
        return;
      }
      if (reload) {
        this.app.stop();
        this.pauseRender = true;
      }

      this.timeSinceStart = 0;
      if (this.tickResolution !== -1) {
        this.__lastTickAt = -this.tickResolution * 2;
      }
      //this.gamedata = gamedata;
      this.allComponents = [];
      this.allLinks = [];
      for (let i = 0; i < (this.gamedata.scenes||[]).length; i++) {
        const scene = this.gamedata.scenes[i];
        this.allComponents.push(... scene.components);
        this.allLinks.push(... scene.links);
      }
      for (let i = 0; i < (this.gamedata.toybox||[]).length; i++) {
        const toy = this.gamedata.toybox[i];
        this.allComponents.push(... toy.components);
        this.allLinks.push(... toy.links);
      }
      
      const toCache = {
        components:this.allComponents,
        links:this.allLinks
      }

      this.allComponents.push(...(this.gamedata.components||[]));
      this.allLinks.push(...(this.gamedata.links||[]));

      this.checkForVideos();

      this.gameobjects.componentLinkCache = Util.prePopulateCache(toCache);
      this.gameobjects.componentIdCache = Util.prePopulateIdCache(toCache);
      this.gameobjects.links = this.allLinks;
      this.gameobjects.components = this.allComponents;

      this.gameobjects.loader = this.loader;

      const {mipmappedTextures, resources, assets} = await this.assets.load(this.allComponents, this.allLinks);
      const allAssets = assets;

      Object.assign(this.resources, resources);
      Object.assign(this.mipmappedTextures, mipmappedTextures);

        //sounds:[],
        //sprites:[],
        //atlases:[],
        //spines:[],
        //videos:[],
        //tilesets:[]

      if (this.gamedata.game && this.gamedata.game.bgcolor) {
        this.app.renderer.backgroundColor = parseInt(this.gamedata.game.bgcolor.replace('#','0x'));
      }

      this.Systems.resetRoot(this.gamedata);

      if (typeof(this.initialTransforms) === 'undefined') {
        this.Systems.startWithScene(this.activeSceneNum);
      } else {
        this.Systems.startWithTransforms(this.initialTransforms, this.layers);
      }

      if (reload) {
        this.app.start();
        this.pauseRender = false;
      }


    },
    restart() {
      this.gameState = 'playing';
      //this.createGame();
    },
    tickFunction(deltaTime) {
/*
      let newTime = new Date().getTime();
this.prevTime = newTime;
*/
      if (this.gameState !== 'playing') {
        return;
      }

      if (this.isFirstFrame) {
        this.startScene({name:'[Game]: ' + this.gamedata.name});
        this.Systems.delayFirstRender = true;
        this.Systems.delayFirstRenderCounter = 0;
        //this.Systems.updateSceneGraph(dt);
        //this.Systems.addComponents(dt);
        //this.Systems.updateCamera(dt);
        //this.Systems.updateSceneGraph(dt);
        //this.Systems.updateCreateToys(dt);

        this.isFirstFrame = false;
        this.waitForFirstFrametoBeRendered = 5;

        return;
      }
      const dt = deltaTime;
      this.Systems.runSystems(dt * this.frameTimeMultiplier);
      this.timeSinceStart += dt;
      if (this.tickResolution === -1) {
        this.$emit("tick", {
          dt,
          timeSinceStart: this.timeSinceStart
        });
      } else {
        if (typeof(this.__lastTickAt) === 'undefined') {
          this.__lastTickAt = -this.tickResolution*2;
        }
        if (this.timeSinceStart >= this.__lastTickAt + this.tickResolution) {
          this.$emit("tick", {
            dt:this.timeSinceStart - this.__lastTickAt,
            timeSinceStart: this.timeSinceStart
          });
          this.__lastTickAt = this.timeSinceStart;
        }
      }

      if (this.timelimit > 0) {
        if (this.timeSinceStart / 1000 > this.timelimit) {
          this.restartGame();
          this.$emit("looped");
        }
      }
      if (this.waitForFirstFrametoBeRendered) {
        if (this.waitForFirstFrametoBeRendered === 1) {
          this.$emit("first-frame");
        }
        this.waitForFirstFrametoBeRendered--;
      }
    },
    createGameObjects(loader, resources, sounds, mipmappedTextures) {

      const dim = this.getDimensions();
      const topLevelComponents = this.getTransforms(this.currentScene)
      const centroid = {x:0,y:0}
      let x1 = 9999999;
      let y1 = 9999999;
      let x2 = -9999999;
      let y2 = -999999;
      (topLevelComponents||[]).forEach( (transform) => {
        const x = transform.transform.pos.x;
        const y = transform.transform.pos.y;
        
        if (x > x2) {
          x2 = x;
        }
        if (y > y2) {
          y2 = y;
        }
        if (x < x1) {
          x1 = x;
        }
        if (y < y1) {
          y1 = y;
        }
      });

      const o = new GameObjects();

      o.addDebug = this.addDebug.bind(this);
      o.userId = ((this.user||{}).identityId) || 'user';
      o.gameId = this.gameId;
      o.entities = this.entityManager;
      o.options = this.usingOptions;
      o.sounds = sounds;
      o.centroid = centroid;
      o.api = this.api;
      o.logStat = this.logStat.bind(this);
      o.storeVariable = this.storeVariable.bind(this);
      o.overrideCamera = this.overrideCamera;
      o.emitVideoPlayingPrompt = this.emitVideoPlayingPrompt.bind(this);
      o.extents = {
        x1,
        x2,
        y1,
        y2
      };
      o.doToast = this.doToast.bind(this);
      const toCache = {
        components:this.allComponents,
        links:this.allLinks
      }
      o.componentLinkCache = Util.prePopulateCache(toCache);
      o.componentIdCache = Util.prePopulateIdCache(toCache);
      o.graphics = this.graphics;
      o.componentLinkNamesCache = {};
      o.askUserInput = this.askUserInput;
      o.links = this.allLinks;
      o.components = this.allComponents;
      o.scenes = this.gamedata.scenes || [];
      o.collisions = this.gamedata.collisions;
      o.systems = this.gamedata.systems;
      o.system = this.gamedata.system;
      o.toybox = this.gamedata.toybox;
      o.features = this.gamedata.features;
      o.screenWidth = this.app.renderer.screen.width;
      o.screenHeight = this.app.renderer.screen.height;
      o.debugSelectTransform = this.debugSelectTransform;
      o.startScene = this.startScene.bind(this);
      o.resumeScene = this.resumeScene.bind(this);
      o.setFirstFrame = this.setFirstFrame.bind(this);
      o.gotoGame  = this.gotoGame.bind(this);
      o.loader = loader;
      o.resources = resources;
      o.mipmappedTextures = mipmappedTextures;
      o.DEBUG_DRAW = this.enableDebug;
      o.debugEntities = [];
      o.debugLogs = {};
      o.game = this.gamedata.game;
      o.setGameState =  (state, message) => {
        this.gameState = state;
        this.$emit("game-state", state, message);
      };
      o.updateLayersOrder = () => {
        return;
      };
      o.data = this.data;
      o.events = [];
      o.localEvents = {};
      o.debugLog = (o) => {
        if (this.enableDebug) {
          o.t = this.timeSinceStart
          this.$emit('debug-log', o);
        }
      }
      o.emitEvent = (event) => {
        this.gameobjects.events.push(event);
        this.$emit('event', {event,t:this.timeSinceStart});
      };
      o.notifyTap = ({ent,component}) => {
        this.$emit('notify-tap', {
          ent,
          component
        });
      }
      o.emitLocalEvent = (ent, event) => {
        if (!ent || !ent.uuid) {
          return;
        }
        const uuid = ent.uuid.uuid;
        if (!this.gameobjects.localEvents[uuid]) {
          this.gameobjects.localEvents[uuid] = [];
        }
        this.gameobjects.localEvents[uuid].push(event);

      };
      o.app = this.app;
      o.toyExtensions = {};
      o.interaction = {}
      o.$store = this.$store;
      return o;
    },
    setFirstFrame() {
      this.isFirstFrame = true;
    },
    startScene(scene) {
      if (!this.app) {
        console.warn('app lost');
        return;
      }
    //return;
      //this.isFirstFrame = true;
      this.pauseRender = true;

      if (scene) {
        this.$emit('start-scene', scene);
      }
      if (this.$ma && (scene||{}).name) {
        this.$ma.trackEvent({
          category:'startScene',
          action:'[Scene] ' + scene.name
        });
      }

      this.app.stop();

      this.raf = window.nextFrame(this.ticker.bind(this));
    },
    resumeScene() {
    //return;
      if (this.raf) {
        window.cancelFrame(this.raf);
        delete this.raf;
      }
      if (!this.app) {
        console.warn('app lost');
      }
      this.$emit('game-started');
      
      if (!this.paused) {
        this.app.start();
        this.pauseRender = false;
      }

    },
    initGame(loader, resources, sounds, mipmappedTextures) {

      let bb = this.$el.getBoundingClientRect();


      this.gameobjects = this.createGameObjects(loader, resources, sounds, mipmappedTextures);
      //this.$store.commit('gameobjects', this.gameobjects);
      this.Systems = new CreateSystems(this.gameobjects, {
        enableLetterbox:this.enableLetterbox
      }, this.app, this.assets);

      if (this.overrideAspect) {
        this.Systems.setOverrideAspectRatio(this.overrideAspect);
      }

      this.callbacks.setDebug(this.Systems.debug);
      if (typeof(this.initialTransforms) === 'undefined') {
        this.Systems.initFromScene(this.activeSceneNum, () => {
          this.startGame();
        });
      } else {
        this.Systems.initFromTransforms(this.initialTransforms, this.layers, () => {
          this.startGame();
        });
      }

    },
    startGame() {
      this.Systems.initVariables(this.gamedata);
      this.Systems.endOfFrame.push( () => {
        this.processIncomingVariables();
      });

      this.prevTime = 0;
      if (this.raf) {
        window.cancelFrame(this.raf);
        delete this.raf;
      }

      this.timeSinceStart = 0;
      if (this.tickResolution !== -1) {
        this.__lastTickAt = -this.tickResolution * 2;
      }

      this.killRender = false;
      //this.raf = window.nextFrame(this.ticker.bind(this));
      //this.app.stop();

      this.Systems.outEvents.on('addInteractiveComponent', this.onAddInteractiveComponent);

      if (!this.paused) {
        this.app.start();
      }

    },
    onAddInteractiveComponent({type}) {
      this.$emit('interactive-type', {type});
    },
    oneTick(deltaTime) {
      //const deltaTime = currentTime - this.prevTime;

      if (this.playing) {
        if (this.meter) {
          this.meter.tickStart();
        }

        if (!this.enableErrorHandler) {
          this.tickFunction(Math.min(deltaTime,50));
        } else {
          try {
            this.tickFunction(Math.min(deltaTime,50));
          } catch (e) {
            console.error(e);
            this.handleFrameError(e);
          }
        }
        //if (!this.pauseRender) {
          //this.app.renderer.render(this.app.stage);
        //}

        if (this.meter) {
          this.meter.tick();
        }

      }

      //this.prevTime = currentTime;
    },
    ticker(_currentTime) {
      if (!this.app) {
        return false;
      }
      let elapsedTime;
      if (this.raf) {
        if (this.killRender) {
          return;
        }
        this.raf = window.nextFrame(this.ticker.bind(this));
        elapsedTime = 30;
      } else {
        if (this.raf) {
          window.cancelFrame(this.raf)
          delete this.raf;
        }
        elapsedTime = this.app.ticker.elapsedMS;
      }
      //if (!this.killRender) {
        //this.raf = window.nextFrame(this.ticker.bind(this));
      //}
      //const currentTime = new Date().getTime();
      //const elapsedTime = currentTime - this.prevTime;
      //if (!this.prevTime) {
        //this.prevTime = currentTime;
        //return;
      //}
      //this.prevTime = currentTime;

      this.oneTick(elapsedTime);

    },
    hasWebGl(return_context) {
      if (!!window.WebGLRenderingContext) {
          var canvas = document.createElement("canvas"),
              names = ["webgl", "experimental-webgl", "moz-webgl", "webkit-3d"],
            context = false;

          for(var i=0;i<4;i++) {
              try {
                  context = canvas.getContext(names[i]);
                  if (context && typeof context.getParameter == "function") {
                      // WebGL is enabled
                      if (return_context) {
                          // return WebGL object if the function's argument is present
                          return {name:names[i], gl:context};
                      }
                      // else, return just true
                      return true;
                  }
              } catch(e) {
                  console.error('err', e);
              }
          }

          // WebGL is supported, but disabled
          return false;
      }

      // WebGL not supported
      return false;
    },
    processIncomingVariables() {
      const nv = this.incomingVariables;
      const variables = []
      toPairs(nv).forEach( ([key,value]) => {
        if (this.incomingVariablesProcessed[key] !== value) {
          variables.push({
            name:key,
            initial:value
          })
          this.incomingVariablesProcessed[key] = value;
        }
      });
      this.Systems.setRootProps(variables);

    }

  },
  mounted() {
    window.addEventListener('keydown', this.onKeyDown);
    window.addEventListener('keyup', this.onKeyUp);

    this.start();

    this.storeSweeper = setInterval(this.runStoreSweep.bind(this), 1300);
    if (this.$vhcheck) {
      this.$vhcheck.on('update', this.resizeListener);
    }

  },
  watch:{
    startPixi(nv) {
      if (nv) {
        this.destroyed = false;
        if (this.loaded) {
          this.gameState = 'playing';
          this.setFirstFrame(true);
          this.$emit('loaded');
        }
      }  else {
        this.setFirstFrame(true);
        if (this.loaded) {
          this.gameState = 'loaded';
        } else {
          this.gameState = 'loading';
        }
        this.doCleanup();
      }
    },
    paused(nv) {
      if (nv) {
        if (this.app) {
          this.app.stop();
        }
        this.pauseRender = true;
      } else {
        if (this.app) {
          this.app.start();
        }
        this.pauseRender = false;
      }
    },
    user: {
      handler(nv) {
        if (this.gameobjects) {
          this.gameobjects.userId = nv.identityId;
        }
      },
      deep:true
    },
    incomingVariables: {
      handler(nv) {
        if (!this.Systems || !this.Systems.setRootProps) {
          return;
        }
        this.processIncomingVariables();
      },
      immediate:true,
      deep:true
    },
    incomingEvents() {
      if (this.incomingEvents.length) {
        this.incomingEvents.forEach( (event) => {
          const {eventName} = event;
          if (event.processed) {
            return;
          }
          this.gameobjects.events.push({eventName});
          event.processed = true
        });
        //this.events = [];
      }
      
    },
    gameState(newState) {
      this.$emit('game-state', newState);
      if (newState === 'lose') {
        this.$ma && this.$ma.trackEvent({
          category:'gameLose',
          action:this.gameName,
          label:this.gameName
        });
        this.$emit('lose');
      } else if (newState === 'win') {
        this.$ma && this.$ma.trackEvent({
          category:'gameWin',
          action:this.gameName,
          label:this.gameName
        });
        this.$emit('win');
      } else if (newState == 'playing') {
        this.$ma && this.$ma.trackEvent({
          category:'gameStart',
          action:this.gameName,
          label:this.gameName
        });
        this.$emit('playing');

        if (this.$route && this.$route.query.fps) {
          setTimeout( () => {
            const fpsHolder = this.$el.querySelectorAll('#fpsmeter')[0];
            this.meter = new FPSMeter(fpsHolder, {
              graph:1
            });
          }, 500);
        }

        values(this.sounds).forEach( (sound) => {
          sound.stop();
        } );

        if (this.app) {
          this.app.destroy(true);
        }
        if (this.raf) {
          this.killRender = true;
          window.cancelFrame(this.raf);
        }

        this.createGame();
      }
    }
  },
  computed:{
    timelimit() {
      return (this.gamedata.game||{}).timelimit || 0;
    },
    //user() {
      //return this.$store.state.user;
    //},
    hasPacker() {
      return this.enablePacker && this.gamedata.build;
    },
    playAreaStyle() {
      return {
        'background-color':this.bgcolor
      }

    },
    disableWebgl() {
      return this.gamedata.disableWebgl;
    },
    activeScene() {
      return (this.gamedata.scenes||[])[this.activeSceneNum];
    },
    bgcolor() {
      if (this.gamedata.game) {
        let bgcolor = this.gamedata.game.bgcolor.toString(16);
        return bgcolor.replace('0x', '#');
      } else {
        return '#000000';
      }
    },
    loadingText() {
      return this.loadingTexts[0];
    },
    uiStateView() {
      if ((this.gamedata.uistates||{})[this.gameState]) {
        return this.gamedata.uistates[this.gameState];
      } else {
        return {
          classes:[], layout:[]
        }
      }
    },
    gameUiClasses() {
      const classes = [];
      if (this.gameState === 'win') {
        classes.push('game-end-overlay-win');
      } else if (this.gameState === 'lose') {
        classes.push('game-end-overlay-lose');
      }
      return classes.join(' ');
    },
      assetsLoaded() {
        const o = (this.spritesLoaded + this.soundsLoaded)/(this.spritesTotal + this.soundsTotal)*100
        if (isNaN(o)) {
          return 50;
        }
        return o;
      },
      assetsLoadedPerc() {
        return this.assetsLoaded.toFixed(0) + "%";
      }
  }
}
</script>

<style>
  .codebreaker-block {
    float:left;
  }
  .codebreaker-selected {
      background-color:red;
  }

.codebreaker-item {
  display: inline-block;
  margin-right: 10px;
}
.codebreaker-enter-active, .codebreaker-leave-active {
  transition: all 1s;
}
.codebreaker-enter, .codebreaker-leave-to /* .codebreaker-leave-active for <2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
.game-overlay > * {
  pointer-events: auto;
}
.game-overlay {
  pointer-events:none;
  position: fixed;
  height:100%;
  left: 0px;
  right: 0px;
  font-weight: bolder;

  animation-duration: 0.30s;
  animation-name: newTile;
  animation-fill-mode: forwards;
  animation-delay: 0.05s;
  transform: scale(0);

}
.game-end-overlay-win {
  background-color: rgba(221, 221, 221, 0.6);
  color: black;
}

.game-end-overlay-lose {
  background-color: rgba(221, 50, 50, 0.6);
  color: white;
}


.my-small-image {
  max-width:64px;
}

.big-image {
  max-width:300px;
  max-height:300px;
  display:block;
  margin-left:auto;
  margin-right:auto;
}
@media (max-width:768px) {
.big-image {
  max-width:200px;
  max-height:200px;
  display:block;
  margin-left:auto;
  margin-right:auto;
}
}
.medium-image {
  max-width:200px;
  max-height:200px;
  display:block;
  margin-left:auto;
  margin-right:auto;
}
@media (max-width:768px) {
.medium-image {
  max-width:80px;
  max-height:80px;
  display:block;
  margin-left:auto;
  margin-right:auto;
}
}

img.center-image {
  display:block;
  margin-left:auto;
  margin-right:auto;
}
.center-image > .image > img {
  display:block;
  margin-left:auto;
  margin-right:auto;
}
.center-image {
  display:block;
  margin-left:auto;
  margin-right:auto;
}


.play-area {
  display:flex;
  flex:1;
  flex-direction:column;
}
.gamecanvas {
  flex: 1;
}

.game-title {
  font-size:2rem;
}

.game-subtitle {
  font-size:1.6rem;
}

.game-title-image {
  max-width:64px;
}

@media (max-width:768px) {
  .game-title {
    font-size:1.1rem;
  }

  .game-subtitle {
    font-size:1.0rem;
  }
.game-title-image {
  max-width:32px;
}

}
@media (min-width:500px) {
  .game-text {
    font-size:1.2rem;
  }
}
@media (min-width:769px) {
  .game-text {
    font-size:2rem;
  }
}

.board-view-progress::-webkit-progress-value { background-color: #242424; }
.board-view-progress::-moz-progress-value { background-color: #242424; }
/*
input.form-control {
    outline: none !important;
    font-family: 'Pathway Gothic One', sans-serif !important;
    -webkit-appearance: none !important;
    border: 3px solid #e6e6e6 !important;
    border-radius: 5px !important;
    background-color: #fff !important;
    line-height: 50px !important;
    vertical-align: middle !important;
    height: 52px !important;
    font-size: 24px !important;
    width: 100% !important;
    padding: 0 15px !important;
}
*/
/*
.modal.is-active {
  position:fixed;
  width:100%;
}
*/
/*
.modal-content {
  position:fixed;
}
*/
</style>
